var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: _vm.documentType + '-edit', params: { id: _vm.document.document_id, lang: _vm.lang } },"rel":"nofollow"},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("Edit")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }